import {
  CREATE,
  CREATE_SUCCEEDED,
  CREATE_FAILED,
} from './action-types';
import utils from '../utils';

const initialState = {
  loading: false,
};

const trainingPlanMapReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case CREATE: {
      return {
        ...state,
        loading: true,
      };
    }
    case CREATE_SUCCEEDED: {
      utils.dialog({
        type: 'reload',
        title: '¡Perfecto!',
        message: 'La petición se ha procesado con éxito',
      });
      return {
        ...state,
        loading: false,
      };
    }

    case CREATE_FAILED: {
      const { error } = action;

      let message = 'La petición no se ha completado con éxito.';

      if (error.response && error.response.data && error.response.data.message) {
        ({ message } = error.response.data);
      }
      utils.dialog({
        type: 'error',
        title: 'Error inesperado',
        message,
      });
      return {
        ...state,
        loading: false,
      };
    }

    default:
      return state;
  }
};

export default trainingPlanMapReducer;
